import { DataSecurityLevel, } from '@office-start/instrumentation-types';
import { generateRequestEvent } from './generateRequestEvent';
export function logRequestEvent(eventName, httpCode, latency, error, fromCache, params, metrics, securityThreshold) {
    if (fromCache === void 0) { fromCache = false; }
    if (params === void 0) { params = {}; }
    if (metrics === void 0) { metrics = []; }
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    generateRequestEvent(eventName, httpCode, latency, error, fromCache, params, metrics, securityThreshold).record();
}
//# sourceMappingURL=logRequestEvent.js.map